function ConsoleService($http) {
    this.http = $http;
    this.maximumNotificationsCount = 100;
    this.notifications = [];
    this.settings = {display: {showNodes: false, showTasks: true, showCommunication: true, showWiki: true}};
}

ConsoleService.portalServerUrl = "https://www.thing-it.com";
ConsoleService.proxyServerUrl = "https://www.thing-it.com";

/**
 *
 */
ConsoleService.prototype.initializeSettings = function () {
    this.clientToken = Utils.getUuid();
    this.http.defaults.headers.common['client-token'] = this.clientToken;

    if (window.localStorage["thing-it.cloudPortalServerUrl"] == undefined && window.localStorage["thing-it.cloudProxyServerUrl"] == undefined) {
        this.portalServerUrl = ConsoleService.portalServerUrl;
        this.proxyServerUrl = ConsoleService.proxyServerUrl;
    } else {
        this.portalServerUrl = window.localStorage["thing-it.cloudPortalServerUrl"];
        this.proxyServerUrl = window.localStorage["thing-it.cloudProxyServerUrl"];
    }

    if (window.localStorage["thing-it.serverMode"] != undefined &&
        window.localStorage["thing-it.host"] != undefined &&
        window.localStorage["thing-it.port"] != undefined) {
        this.settings.serverMode = window.localStorage["thing-it.serverMode"];
        this.settings.useLocalNodeBoxIfAvailable = JSON.parse(window.localStorage["thing-it.useLocalNodeBoxIfAvailable"]);
        this.settings.host = window.localStorage["thing-it.host"];
        this.settings.port = window.localStorage["thing-it.port"];

        if (this.settings.serverMode === "local") {
            this.connectionMode = "local";
        } else {
            this.connectionMode = "proxy";
        }
    }
    else {
        this.settings.serverMode = "tic";
        this.settings.useLocalNodeBoxIfAvailable = false;
        this.connectionMode = "proxy";
    }

    this.logDebug("Server Mode: " + this.settings.serverMode);
    this.logDebug("Use local Gateway: " + this.settings.useLocalNodeBoxIfAvailable);
    this.logDebug("Host: " + this.settings.host);
    this.logDebug("Port: " + this.settings.port);

    if (window.localStorage["thing-it.display.showNodes"] != undefined) {
        this.settings.display.showNodes = JSON.parse(window.localStorage["thing-it.display.showNodes"]);
    }

    if (window.localStorage["thing-it.display.showTasks"] != undefined) {
        this.settings.display.showTasks = JSON.parse(window.localStorage["thing-it.display.showTasks"]);
    }

    if (window.localStorage["thing-it.display.showCommunication"] != undefined) {
        this.settings.display.showCommunication = JSON.parse(window.localStorage["thing-it.display.showCommunication"]);
    }

    if (window.localStorage["thing-it.display.showWiki"] != undefined) {
        this.settings.display.showWiki = JSON.parse(window.localStorage["thing-it.display.showWiki"]);
    }
};

/**
 *
 */
ConsoleService.prototype.applySettings = function () {
    window.localStorage["thing-it.serverMode"] = this.settings.serverMode;
    window.localStorage["thing-it.useLocalNodeBoxIfAvailable"] = JSON.stringify(this.settings.useLocalNodeBoxIfAvailable);
    window.localStorage["thing-it.host"] = this.settings.host;
    window.localStorage["thing-it.port"] = this.settings.port;
    window.localStorage["thing-it.display.showNodes"] = JSON.stringify(this.settings.display.showNodes);
    window.localStorage["thing-it.display.showTasks"] = JSON.stringify(this.settings.display.showTasks);
    window.localStorage["thing-it.display.showCommunication"] = JSON.stringify(this.settings.display.showCommunication);
    window.localStorage["thing-it.display.showWiki"] = JSON.stringify(this.settings.display.showWiki);

    if (this.settings.serverMode == 'tic') {
        // Initialize with assumption of no local connection

        this.connectionMode = 'proxy';
    }
};

/**
 *
 */
ConsoleService.prototype.saveCloudServerUrls = function (portalServerUrl, proxyServerUrl) {
    if (portalServerUrl && proxyServerUrl) {
        this.portalServerUrl = portalServerUrl;
        this.proxyServerUrl = proxyServerUrl;
        window.localStorage["thing-it.cloudPortalServerUrl"] = portalServerUrl;
        window.localStorage["thing-it.cloudProxyServerUrl"] = proxyServerUrl;
    } else {
        this.portalServerUrl = ConsoleService.portalServerUrl;
        this.proxyServerUrl = ConsoleService.proxyServerUrl;
        window.localStorage["thing-it.cloudPortalServerUrl"] = ConsoleService.portalServerUrl;
        window.localStorage["thing-it.cloudProxyServerUrl"] = ConsoleService.proxyServerUrl;
    }
};

ConsoleService.prototype.useLocalNodeBoxIfAvailable = function () {
    return this.settings.useLocalNodeBoxIfAvailable;
};

/**
 * Checks whether the local Node Box can be reached and switches the connectionMode accordingly.
 *
 * Returns true if the connectionMode value was changed.
 */
ConsoleService.prototype.tryLocalConnection = function () {
    var deferred = $.Deferred();
    var changedConnectionMode = false;

    // Retrieving /settings is just a "ping"

    this.get(this.localRootUrl() + "/settings").done(function (settings) {
        changedConnectionMode = (this.connectionMode !== "local");
        this.connectionMode = "local";
        this.localSettings = settings;

        this.logDebug("Can reach local Node Box. Changed connection mode: " + changedConnectionMode);
        deferred.resolve(changedConnectionMode);
    }.bind(this)).fail(function () {
        changedConnectionMode = (this.connectionMode !== "proxy");
        this.connectionMode = "proxy";
        this.localSettings = null;

        this.logDebug("Cannot reach local Node Box. Changed connection mode: " + changedConnectionMode);
        deferred.resolve(changedConnectionMode);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.hasLocalConnection = function () {
    return this.connectionMode == 'local';
}

/**
 *
 */
ConsoleService.prototype.operatesInLocalMode = function () {
    return this.settings.serverMode == 'local' || (this.settings.serverMode == 'tic'
        && this.settings.useLocalNodeBoxIfAvailable && this.hasLocalConnection());
};


/**
 *
 */
ConsoleService.prototype.localRootUrl = function () {
    return "http://" + this.settings.host + ":" + this.settings.port;
};

/**
 *
 */
ConsoleService.prototype.proxyRootUrl = function () {
    return this.proxyServerUrl;
};

/**
 *
 */
ConsoleService.prototype.portalRootUrl = function () {
    return this.portalServerUrl;
};

/**
 *
 */
ConsoleService.prototype.getRootUrl = function () {
    if (this.operatesInLocalMode()) {
        return this.localRootUrl();
    } else {
        return this.proxyRootUrl();
    }
};

/**
 *
 */
ConsoleService.prototype.get = function (url) {
    var deferred = $.Deferred();

    this.logDebug(">>> GET " + url);

    this.http.get(url).success(function (data) {
        this.logDebug("<<< GET ", data);
        deferred.resolve(data);
    }.bind(this)).error(function (error) {
        this.logError("!!! GET", error);
        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.post = function (url, data, headers) {
    var deferred = $.Deferred();

    this.logDebug(">>> POST " + url);

    this.http({
        url: url,
        data: this.filterTransient(data),
        method: 'POST',
        headers: headers ? headers : {}
    }).success(function (data) {
        this.logDebug("<<< POST", data);
        deferred.resolve(data);
    }.bind(this)).error(function (error) {
        this.logError("!!! POST", error);
        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.put = function (url, data) {
    var deferred = $.Deferred();

    this.logDebug(">>> PUT " + url);

    this.http.put(url, this.filterTransient(data)).success(function (data) {
        this.logDebug("<<< PUT", data);

        deferred.resolve(data);
    }.bind(this)).error(function (data) {
        this.logError("!!! PUT", error);

        deferred.reject(data);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.delete = function (url) {
    var deferred = $.Deferred();

    this.logDebug("DELETE " + url);

    this.http.delete(url).success(function (data) {
        this.logDebug("<<< DELETE", data);

        deferred.resolve(data);
    }.bind(this)).error(function (data) {

        this.logError("!!! DELETE", error);
        deferred.reject(data);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.filterTransient = function (data) {
    return Utils
        .cloneFiltered(data, /\_\_|\$\$/);
};


/**
 * TODO May homogenize local URL to contain UUID as well.
 */
ConsoleService.prototype.getNodeRootUrl = function (node) {
    if (this.operatesInLocalMode()) {
        return this.getRootUrl();
    }
    else {
        return this.getRootUrl() + "/nodes/" + node.uuid;
    }
};

/**
 *
 * @param node
 * @returns {string}
 */
ConsoleService.prototype.getEventNamespaceUrl = function (node) {
    this.logDebug(node);

    if (this.operatesInLocalMode()) {
        return this.getRootUrl() + "/events";
    }
    else {
        return this.getRootUrl() + "/nodes/" + node.uuid + "/events";
    }
};

/**
 *
 * @param node
 * @returns {string}
 */
ConsoleService.prototype.getComponentRootUrl = function (node) {
    if (this.operatesInLocalMode()) {
        return this.getRootUrl();
    }
    else {
        return this.getRootUrl() + "/thing-it-node";
    }
};

/**
 *
 */
ConsoleService.prototype.getCustomerStyle = function (customer) {
    return Utils.ajax(this.getRootUrl() + "/customers/" + customer + "/mobileStyle", "GET",
        "application/json");
};

/**
 * For network scan.
 */
ConsoleService.prototype.ping = function (testIp) {
    var deferred = $.Deferred();

    this.get("http://" + testIp + ":3001/settings").done(function (settings) {
        settings.ipAddress = testIp;

        deferred.resolve(settings);
    }.bind(this)).fail(function (error) {
        deferred.reject(error);
    });

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.getServerSettings = function () {
    return this.get(this.getRootUrl() + "/settings");
};

/**
 *
 */
ConsoleService.prototype.updateFirmware = function (node) {
    return this.post(this.getNodeRootUrl(node) + "/firmware");
};

/**
 *
 */
ConsoleService.prototype.getDeviceTypes = function () {
    var deferred = $.Deferred();

    this.get(this.getRootUrl() + "/plugins").done(function (deviceTypes) {
        this.deviceTypes = deviceTypes; // TODO May need to change if Device Types vary between Nodes

        deferred.resolve(deviceTypes);
    }.bind(this)).fail(function (error) {
        deferred.reject(error);
    });

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.login = function (credentials) {
    var deferred = $.Deferred();

    this.logDebug(">>> POST " + this.getRootUrl() + "/login");

    // TODO For now always log into thing-it.com

    this.http.post(this.proxyRootUrl() + "/login", JSON.stringify(credentials)).success(function (user, status, headers) {
        this.logDebug("<<< POST", user);

        this.sid = headers()['ti-sid'];

        deferred.resolve(user);
    }.bind(this)).error(function (error) {
        this.logError("!!! POST", error);
        deferred.reject(error);
    }.bind(this));

    return deferred.promise();

};

/**
 *
 */
ConsoleService.prototype.changePasswordAndLogin = function (account, password, newPassword) {
    return this.post(this.getRootUrl() + "/user/changePasswordAndLogin",
        JSON.stringify({
            account: account,
            password: password,
            newPassword: newPassword
        }));
};

/**
 *
 */
ConsoleService.prototype.registerUser = function (account, password, firstName, lastName) {
    return this.post(this.getRootUrl() + "/user", JSON.stringify({
        account: account,
        password: password,
        firstName: firstName,
        lastName: lastName
    }));
};

/**
 *
 */
ConsoleService.prototype.logout = function () {
    return this.post(this.getRootUrl() + "/logout");
};

/**
 *
 */
ConsoleService.prototype.getMeshes = function () {
    var deferred = $.Deferred();

    this.get(this.getRootUrl() + "/meshes").done(function (meshes) {
        Mesh.bindAll(this.deviceTypes, meshes);

        deferred.resolve(meshes);
    }.bind(this)).fail(function (error) {
        deferred.reject(error);
    });

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.getMesh = function (mesh) {
    var deferred = $.Deferred();

    this.get(this.getRootUrl() + "/meshes/" + mesh._id).done(function (mesh) {
        Mesh.bind(this.deviceTypes, mesh);

        deferred.resolve(mesh);
    }.bind(this)).fail(function (error) {
        deferred.reject(error);
    });

    return deferred.promise();
};

/**
 * @deprecated
 */
ConsoleService.prototype.bindNode = function (node, mesh) {
    return Node.bind(this.deviceTypes,
        node, mesh);
};

/**
 *
 */
ConsoleService.prototype.getNode = function (node, mesh) {
    var deferred = $.Deferred();

    this.get(this.getNodeRootUrl(node) + "/configuration").done(function (data) {

        // Node and Mesh are only set for tic mode

        if (node) {
            data.configuration.uuid = node.uuid; // TODO Not elegant
            data.configuration.nodeBoxUuid = data.nodeBoxUuid; // TODO Not elegant
        }

        var newNode = Node.bind(this.deviceTypes, data.configuration, mesh);

        deferred.resolve(newNode);
    }.bind(this)).fail(function (error) {
        this.logError(error);

        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.getNodeState = function (node) {
    return this.get(this.getNodeRootUrl(node) + "/state");
};


/**
 *
 */
ConsoleService.prototype.pollNode = function (node) {
    return this.post(this.getNodeRootUrl(node) + "/poll");
};

/**
 *
 */
ConsoleService.prototype.connectMeshNamespace = function (io, id) {
    var deferred = jQuery.Deferred();

    Utils.ajax(this.proxyRootUrl() + "/meshes/" + id + "/connect", "POST",
        "application/json").done(function () {
        // TODO Is transport needed

        var transports = ['websocket'];

        if ("WebSocket" in window && WebSocket.CLOSED > 2) {
            transports: ['websocket', 'xhr-polling']
        } else {
            transports: ['xhr-polling']
        }

        console.log("Connecting Namespace " + this.proxyRootUrl() + "/meshes/" + id);

        deferred.resolve(io.connect(this.proxyRootUrl() + "/meshes/" + id, {
            transports: transports,
            reconnection: true,
            reconnectionDelay: 1000, reconnectionDelayMax: 5000,
            reconnectionAttempts: 5
        }));
    }.bind(this)).fail(function (error) {
        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.connectNodeNamespace = function (io, node) {
    var transports;

    if ("WebSocket" in window && WebSocket.CLOSED > 2) {
        transports = ['websocket', 'xhr-polling']
    } else {
        transports = ['xhr-polling']
    }

    var namespace = io.connect(this.getEventNamespaceUrl(node), {
        transports: ['websocket'],
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 5
    });

    this.logDebug("Connecting WebSocket Namespace " + this.getEventNamespaceUrl(node));

    return namespace;
};

/**
 *
 */
ConsoleService.prototype.getPages = function (mesh) {
    return Utils.ajax(this.getRootUrl() + "/meshes/" + mesh._id + "/pages", "GET",
        "application/json");
};

/**
 *
 */
ConsoleService.prototype.getPage = function (mesh, page) {
    return Utils.ajax(this.getRootUrl() + "/meshes/" + mesh._id + "/pages/" + page._id, "GET",
        "application/json");
};

/**
 *
 */
ConsoleService.prototype.getChildPages = function (mesh, page) {
    return Utils.ajax(this.getRootUrl() + "/meshes/" + mesh._id + "/pages/" + page._id + "/childPages", "GET",
        "application/json");
};

/**
 *
 */
ConsoleService.prototype.getChannels = function (mesh) {
    return Utils.ajax(this.getRootUrl() + "/meshes/" + mesh._id + "/channels", "GET",
        "application/json");
};

/**
 *
 */
ConsoleService.prototype.getChannel = function (mesh, channel) {
    return Utils.ajax(this.getRootUrl() + "/meshes/" + mesh._id + "/channels/" + channel._id, "GET",
        "application/json");
};

/**
 *
 */
ConsoleService.prototype.createPost = function (mesh, channel, content, type) {
    return Utils.ajax(this.getRootUrl() + "/meshes/" + mesh._id + "/channels/" + channel._id + "/posts", "POST",
        "application/json", JSON.stringify({content: content, type: type}));
};

/**
 *
 */
ConsoleService.prototype.pairGateway = function (meshLabel, account, password) {
    var deferred = $.Deferred();
    var headers = {'ti-sid': this.sid}; // Homogenize basic and token-based

    // TODO Not used yet - use later

    if (account && password) {
        headers.Authorization = 'Basic ' + window.btoa(account + ':' + password);
    }

    this.post("http://" + this.settings.host + ':' + this.settings.port + '/pair', this.filterTransient({
        mesh: meshLabel,
        server: this.proxyRootUrl(), // TODO Put in header
        account: account,
        password: password
    }), headers).done(function (gateway) {
        this.localSettings.uuid = gateway.uuid;
        deferred.resolve();
    }.bind(this)).fail(function (error) {
        deferred.reject(error);
    }.bind(this));

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.callNodeService = function (node, service, parameters) {
    return this.post(this.getNodeRootUrl(node) + "/services/" + service.id, this.filterTransient(parameters));
};

/**
 *
 */
ConsoleService.prototype.playStoryboard = function (node, storyboard) {
    return this.post(this.getNodeRootUrl(node) + "/storyboards/" + storyboard.id + "/play");
};

/**
 *
 */
ConsoleService.prototype.pauseStoryboard = function (node, storyboard) {
    return this.post(this.getNodeRootUrl(node) + "/storyboards/" + storyboard.id + "/pause");
};

/**
 *
 */
ConsoleService.prototype.stopStoryboard = function (node, storyboard) {
    return this.post(this.getNodeRootUrl(node) + "/storyboards/" + storyboard.id + "/stop");
};

/**
 *
 */
ConsoleService.prototype.callDeviceService = function (device, service, parameters) {
    return this.post(this.getNodeRootUrl(device.__node) + "/devices/" + device.id
        + "/services/" + service, this.filterTransient(parameters));
};

/**
 *
 */
ConsoleService.prototype.callActorService = function (actor, service,
                                                      parameters) {
    return this.post(this.getNodeRootUrl(actor.__device.__node) + "/devices/" + actor.__device.id
        + "/actors/" + actor.id + "/services/" + service, this.filterTransient(parameters));
};

/**
 *
 */
ConsoleService.prototype.pushSensorValue = function (sensor, value) {
    return this.post(this.getNodeRootUrl(sensor.__device.__node) + "/devices/" + sensor.__device.id
        + "/sensors/" + sensor.id + "/data", {
        data: sensor._value
    });
};

/**
 *
 */
ConsoleService.prototype.pushSensorEvent = function (sensor, event) {
    return this.post(this.getNodeRootUrl(sensor.device.__node) + "/devices/" + sensor.device.id
        + "/sensors/" + sensor.id + "/event", {
        type: event
    });
};

/**
 *
 */
ConsoleService.prototype.getDeviceStateResourceUrl = function (device, stateVariable) {
    return this.getNodeRootUrl(device.__node) + "/devices/" + device.id
        + "/state/" + stateVariable + "/resource";
};

/**
 *
 */
ConsoleService.prototype.getDataValue = function (node, data) {
    return this.get(this.getNodeRootUrl(node) + "/data/" + data.id);
};

/**
 *
 */
ConsoleService.prototype.registerDevice = function (node, device) {
    return this.post(this.getNodeRootUrl(node) + "/devices/" + device.uuid + "/register", device);
};

/**
 *
 */
ConsoleService.prototype.getComponentPluginDirectory = function (component) {
    if (!component) {
        return null;
    }

    if (component.device) {
        if (!component.device.__type) {
            return null;
        }

        // Actors and Sensors

        return this.getComponentRootUrl()
            + component.device.__type.pluginDirectory + "/web/";
    }
    else {
        if (!component.__type) {
            return null;
        }

        return this.getComponentRootUrl() + component.__type.pluginDirectory + "/web/";
    }
};

/**
 *
 */
ConsoleService.prototype.getComponentPluginPath = function (component) {
    if (!component || !component.__type) {
        return null;
    }

    return this.getComponentPluginDirectory(component) + component.__type.family + ".html";
};

/**
 *
 */
ConsoleService.prototype.getUsers = function (node) {
    return this.get(this.getNodeRootUrl(node) + "/users");
};

/**
 *
 */
ConsoleService.prototype.getUser = function (id) {
    return this.get(this.getNodeRootUrl(node) + "/users/" + id);
};

/**
 *
 */
ConsoleService.prototype.createUser = function (node, user) {
    return this.post(this.getNodeRootUrl(node) + "/users", user);
};

/**
 *
 */
ConsoleService.prototype.updateUser = function (node, user) {
    return this.put(this.getNodeRootUrl(node) + "/users/" + user);
};

/**
 *
 */
ConsoleService.prototype.createDevice = function (node, device) {
    return this.post(this.getNodeRootUrl(node) + "/configuration/devices/", device);
};

/**
 *
 */
ConsoleService.prototype.updateDevice = function (device) {
    return this.put(this.getNodeRootUrl(device.__node) + "/configuration/devices/" + device.id, device);
};

/**
 *
 */
ConsoleService.prototype.deleteDevice = function (device) {
    return this.delete(this.getNodeRootUrl(device.__node) + "/configuration/devices/" + device.id);
};

/**
 *
 */
ConsoleService.prototype.createService = function (node, service) {
    return this.post(this.getNodeRootUrl(node) + "/configuration/services", service);
};

/**
 *
 */
ConsoleService.prototype.updateService = function (node, service) {
    return this.put(this.getNodeRootUrl(node) + "/configuration/services/" + service.id, service);
};

/**
 *
 */
ConsoleService.prototype.deleteService = function (node, service) {
    return this.delete(this.getNodeRootUrl(node) + "/configuration/services/" + service.id);
};

/**
 *
 */
ConsoleService.prototype.createGroup = function (node, group) {
    return this.post(this.getNodeRootUrl(node) + "/configuration/groups", group);
};

/**
 *
 */
ConsoleService.prototype.updateGroup = function (node, group) {
    return this.put(this.getNodeRootUrl(node) + "/configuration/groups/" + group.id, group);
};

/**
 *
 */
ConsoleService.prototype.deleteGroup = function (node, group) {
    return this.delete(this.getNodeRootUrl(node) + "/configuration/groups/" + group.id);
};

/**
 *
 */
ConsoleService.prototype.createEventProcessor = function (node, eventProcessor) {
    return this.post(this.getNodeRootUrl(node) + "/configuration/eventProcessors", eventProcessor);
};

/**
 *
 */
ConsoleService.prototype.updateEventProcessor = function (node, eventProcessor) {
    return this.put(this.getNodeRootUrl(node) + "/configuration/eventProcessors/" + eventProcessor.id, eventProcessor);
};

/**
 *
 */
ConsoleService.prototype.deleteEventProcessor = function (node, eventProcessor) {
    return this.delete(this.getNodeRootUrl(node) + "/configuration/eventProcessors/" + eventProcessor.id);
};

/**
 *
 */
ConsoleService.prototype.createStoryboard = function (node, storyboard) {
    return this.post(this.getNodeRootUrl(node) + "/configuration/storyboards", storyboard);
};

/**
 *
 */
ConsoleService.prototype.updateStoryboard = function (node, storyboard) {
    return this.put(this.getNodeRootUrl(node) + "/configuration/storyboards/" + storyboard.id, storyboard);
};

/**
 *
 */
ConsoleService.prototype.deleteStoryboard = function (node, storyboard) {
    return this.delete(this.getNodeRootUrl(node) + "/configuration/storyboards/" + storyboard.id);
};

/**
 *
 */
ConsoleService.prototype.createJob = function (node, job) {
    return this.post(this.getNodeRootUrl(node) + "/configuration/jobs", job);
};

/**
 *
 */
ConsoleService.prototype.updateJob = function (node, job) {
    return this.put(this.getNodeRootUrl(node) + "/configuration/jobs/" + job.id, job);
};

/**
 *
 */
ConsoleService.prototype.deleteJob = function (node, job) {
    return this.delete(this.getNodeRootUrl(node) + "/configuration/jobs/" + job.id);
};

/**
 *
 */
ConsoleService.prototype.uploadPhoto = function (node, uri, fileName) {
    var deferred = $.Deferred();
    var options = new FileUploadOptions();

    options.fileKey = "Test";
    options.fileName = fileName;
    options.mimeType = "image/jpeg";
    options.params = {
        val1: "some value",
        val2: "some other value"
    };

    var fileTransfer = new FileTransfer();

    fileTransfer.upload(uri, this.getNodeRootUrl(node) + "/files", function () {
        deferred.resolve();
    }.bind(this), function (error) {
        deferred.reject(error);
    }.bind(this), options);

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.startFlow = function (mesh, flow) {
    var deferred = $.Deferred();

    this.post(this.getRootUrl() + "/meshes/" + mesh._id + "/flows/" + flow.id + "/start").done(function () {
        deferred.resolve();
    }.bind(this), function (error) {
        deferred.reject(error);
    }.bind(this), options);

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.getTasks = function (mesh) {
    return this.get(this.getRootUrl() + '/meshes/' + mesh._id + '/tasks/');
};

/**
 *
 */
ConsoleService.prototype.getProcessInstance = function (processInstance) {
    return this.get(this.getRootUrl() + '/meshes/' + mesh._id + '/processInstances/' + processInstance.oid);
};

/**
 *
 */
ConsoleService.prototype.uploadPhotoAndStartFlow = function (uri, mesh, flow, fileName) {
    var deferred = $.Deferred();
    var options = new FileUploadOptions();

    options.fileKey = "Test";
    options.fileName = fileName;
    options.mimeType = "image/jpeg";

    var fileTransfer = new FileTransfer();

    fileTransfer.upload(uri, this.getRootUrl() + "/meshes/" + mesh._id + "/flows/" + flow.id + "/startWithFile", function () {
        deferred.resolve();
    }.bind(this), function (error) {
        deferred.reject(error);
    }.bind(this), options);

    return deferred.promise();
};

/**
 *
 */
ConsoleService.prototype.activateTask = function (oid) {
    return this.post(this.getRootUrl() + "/tasks/" + oid + "/activate");
};

/**
 *
 */
ConsoleService.prototype.completeTask = function (task) {
    return this.post(this.getRootUrl() + "/tasks/" + task.oid + "/complete", task.data);
};

/**
 *
 */
ConsoleService.prototype.suspendTask = function (oid) {
    return this.post(this.getRootUrl() + "/tasks/" + oid + "/suspend");
};

/**
 *
 */
ConsoleService.prototype.suspendAndSaveTask = function (task) {
    return this.post(this.getRootUrl() + "/tasks/" + task.oid + "/suspendAndSave", task.data);
};

/**
 *
 */
ConsoleService.prototype.getProcessInstance = function (processInstance) {
    return this.get(this.getRootUrl() + "/processInstances/" + processInstance.oid);
};

/**
 *
 */
ConsoleService.prototype.getAssetByUuid = function (uuid) {
    return this.get(this.getRootUrl() + "/assets/" + uuid);
};

/**
 *
 */
ConsoleService.prototype.getFilePath = function (node, uri) {
    if (!uri) {
        return null;
    }

    return this.getNodeRootUrl(node) + "/files/" + uri;
};

/*
 *
 */
ConsoleService.prototype.logError = function () {
    this.notifications.unshift({
        type: "error",
        timestamp: new Date().getTime(),
        content: this.concatenateArray(arguments)
    });

    if (this.notifications.length > this.maximumNotificationsCount) {
        this.notifications.pop();
    }

    console.error.apply(console, arguments);
};

/*
 *
 */
ConsoleService.prototype.logWarning = function (content) {
    this.notifications.unshift({
        type: "warning",
        timestamp: new Date().getTime(),
        content: this.concatenateArray(arguments)
    });

    if (this.notifications.length > this.maximumNotificationsCount) {
        this.notifications.pop();
    }

    console.log.apply(console, arguments);
};

/*
 *
 */
ConsoleService.prototype.logInfo = function (content) {
    this.notifications.unshift({
        type: "info",
        timestamp: new Date().getTime(),
        content: this.concatenateArray(arguments)
    });

    if (this.notifications.length > this.maximumNotificationsCount) {
        this.notifications.pop();
    }

    console.log.apply(console, arguments);
};

/*
 *
 */
ConsoleService.prototype.logDebug = function (content) {
    this.notifications.unshift({
        type: "debug",
        timestamp: new Date().getTime(),
        content: this.concatenateArray(arguments)
    });

    if (this.notifications.length > this.maximumNotificationsCount) {
        this.notifications.pop();
    }

    console.log.apply(console, arguments);
};

/*
 *
 */
ConsoleService.prototype.concatenateArray = function (array) {
    var string = "";

    for (var n in array) {
        if (n > 0) {
            string += " ";
        }

        string += array[n];
    }

    return string;
};

angular.module('ThingItMobile.ConsoleService', [])
    .service('consoleService', ConsoleService);
